import styled from 'styled-components';
import { useSelectedCollectedOrderDataValueContextHook } from '../../contexts/SelectedCollectedOrderDataContext';
import { useState } from 'react';
import { ModalCancelOrder } from './modals/modal-cancel-orders/modal-cancel-orders';

const StyledContainer = styled.div`
    padding: 10px;
`;

const StyledCardListWrapper = styled.div`
    display: flex;
    gap: 10px;
`;

const StyledCard = styled.div`
    width: 100%;
    background-color: #fff;
    padding: 10px;
    border-radius: 3px;
    border: 1px solid #e0e0e0;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .title{
        font-size: 16px;
        font-weight: 600;
    }
    
    .content{
        font-size: 16px;
    }

    &.cancel{
        border-color: var(--redColor1);
        color: var(--redColor1);
        cursor: pointer;
    }
`;
export function WegetCollectedSummary(props) {
    const selectedCollectedOrderDataValueContextHook = useSelectedCollectedOrderDataValueContextHook();
    const commerceApiStoreInfo = selectedCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.commerceApiStoreInfo;
    const newOrders = selectedCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.newOrders;
    const cancelOrders = selectedCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.cancelOrders;

    const orderCountAggregation = getOrderCountAggregation({ newOrders: newOrders, cancelOrders: cancelOrders });

    const [cancelOrdersModalOpen, setCancelOrdersModalOpen] = useState(false);

    return (
        <>
            <StyledContainer>
                <StyledCardListWrapper>
                    <StyledCard>
                        <div className='title'>스토어명</div>
                        <div className='content'>{commerceApiStoreInfo?.storeName}</div>
                    </StyledCard>
                    <StyledCard>
                        <div className='title'>총 신규주문</div>
                        <div className='content'>{orderCountAggregation?.totalCount} 건</div>
                    </StyledCard>
                    <StyledCard>
                        <div className='title'>발주 전 신규주문</div>
                        <div className='content'>{orderCountAggregation?.notYet} 건</div>
                    </StyledCard>
                    <StyledCard>
                        <div className='title'>발주 후 신규주문</div>
                        <div className='content'>{orderCountAggregation?.ok} 건</div>
                    </StyledCard>
                    <StyledCard className='cancel' onClick={() => setCancelOrdersModalOpen(true)}>
                        <div className='title'>취소요청</div>
                        <div className='content'>{orderCountAggregation?.cancel} 건</div>
                    </StyledCard>
                </StyledCardListWrapper>
            </StyledContainer>

            {cancelOrdersModalOpen &&
                <ModalCancelOrder
                    open={cancelOrdersModalOpen}
                    onClose={() => setCancelOrdersModalOpen(false)}
                    cancelOrders={cancelOrders}
                />
            }
        </>
    );
}

function getOrderCountAggregation({ newOrders, cancelOrders }) {
    const okCount = newOrders?.filter(order => order?.content?.productOrder?.placeOrderStatus === 'OK')?.length;
    const notYetCount = newOrders?.filter(order => order?.content?.productOrder?.placeOrderStatus === 'NOT_YET')?.length;
    return {
        totalCount: newOrders?.length,
        ok: okCount,
        notYet: notYetCount,
        cancel: cancelOrders?.length
    }
}